// The theme the dashboard shows: its root element's, which also follows a
// preview on the profile page
export function getShownTheme() {
  return document.documentElement.getAttribute('data-theme') === 'dark'
    ? 'dark'
    : 'light';
}

export function subscribeShownTheme(callback) {
  const observer = new MutationObserver(() => callback(getShownTheme()));
  observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['data-theme'],
  });
  return () => observer.disconnect();
}
